import React from "react";

type AdminGuardProps = {
  children: React.ReactNode;
};

/**
 * AdminGuard for nested /admin routes.
 *
 * NOTE:
 * Actual RBAC enforcement already happens in App.tsx via:
 *   <AdminRoute identity={identity}>
 *     <AdminRouter />
 *   </AdminRoute>
 *
 * This wrapper is intentionally minimal so it doesn't rely on a non-existent
 * `auth` singleton and avoids breaking the build. You can later add
 * extra admin-specific checks here if needed.
 */
export default function AdminGuard({ children }: AdminGuardProps) {
  return <>{children}</>;
}